export default function SoccerIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      {/* Goal frame and net */}
      <path d="M34 10h22v44H34" fill="none" stroke="#F4F7FA" strokeWidth="4" strokeLinejoin="round" />
      <path
        d="M40 10v44M46 10v44M52 10v44M34 18h22M34 26h22M34 34h22M34 42h22M34 50h22"
        stroke="#F4F7FA"
        strokeOpacity="0.45"
        strokeWidth="1.5"
      />
      {/* Motion lines */}
      <path d="M4 40h12M7 47h10M9 33h8" stroke="#3FA34D" strokeWidth="3" strokeLinecap="round" />
      {/* Ball */}
      <circle cx="30" cy="40" r="12" fill="#F4F7FA" stroke="#1B1F26" strokeWidth="2" />
      <path d="M30 34.5l5 3.6-1.9 5.9h-6.2L25 38.1z" fill="#1B1F26" />
      <path d="M30 34.5V28.5M35 38.1l5.6-1.8M33.1 44l3.4 4.6M26.9 44l-3.4 4.6M25 38.1l-5.6-1.8" stroke="#1B1F26" strokeWidth="1.6" />
    </svg>
  );
}
